export const PERMISSION_DENIED_EVENT = 'safesea:permission-denied';

export const redirectToPermissionDenied = () => {
  window.dispatchEvent(new CustomEvent(PERMISSION_DENIED_EVENT));
};
